class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetButton = this.querySelector('.facets__button-show');
    if (facetButton) {
      facetButton.onclick = (event) => {
        event.currentTarget.querySelector('.label-hide').classList.toggle('hidden');
        event.currentTarget.querySelector('.label-show').classList.toggle('hidden');
        if (!event.currentTarget.classList.contains('facets__button-show_up')) {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let width = this.querySelector('.facets__container').offsetWidth + 32;
            this.querySelector('.facets__container').classList.add('hide');
            this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
            document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
            document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
          }
          else {
            this.querySelector('.facets__container').classList.remove('hide');
            this.querySelector('.facets__container').style.marginLeft = '0';
            document.querySelector('.products-grid').style.marginLeft = '0';
            document.querySelector('.facets__top').style.marginLeft = '0';
          }
          if (document.querySelector('.products-grid'))
            document.querySelector('.products-grid').classList.toggle('full-width');
          if (document.querySelector('.collection-results'))
            document.querySelector('.collection-results').classList.toggle('full-width');
        }
        else {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let height = this.querySelector('.facets__container').offsetHeight;
            this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
          }
          else {
            this.querySelector('.facets__wrapper').style.marginTop = '0';
          }
        }
      }

      const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');
      let prevWidth = 0;
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;

        if (!facetButton.classList.contains('facets__button-show_up') && entry.contentRect.width !== prevWidth) {
          if (facetButton.querySelector('.label-hide').classList.contains('hidden')) {
            if (entry.contentRect.width > 749) {
              let width = this.querySelector('.facets__container').offsetWidth + 32;
              this.querySelector('.facets__container').classList.add('hide');
              this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
              document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
              document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
            }
            else {
              this.querySelector('.facets__container').classList.remove('hide');
              this.querySelector('.facets__container').style.marginLeft = '0';
              document.querySelector('.products-grid').style.marginLeft = '0';
              document.querySelector('.facets__top').style.marginLeft = '0';
            }
          }
        }
        else {
          if (facetButton.querySelector('.label-hide').classList.contains('hidden') && entry.contentRect.width !== prevWidth) {
            if (entry.contentRect.width > 749 ) {
              let height = this.querySelector('.facets__wrapper').offsetHeight;
              this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
              prevWidth = entry.contentRect.width;
            }
            else {
              this.querySelector('.facets__wrapper').style.marginTop = '0';
            }
          }
        }
        
      });
      sectionResizeObserver.observe(collectionGridSection);
    }

    document.addEventListener('click', (e) => {
      const detailsList = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const details = e.target.closest(".facets__disclosure[open]");

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute("open");
        })
      }
    })
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams) :
        FacetFiltersForm.renderSectionFromFetch(url, event, searchParams);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, searchParams) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        // Use the searchParams passed from renderPage (the new filter state)
        FacetFiltersForm.renderFilters(html, event, searchParams);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    // Use the searchParams passed from renderPage (the new filter state)
    FacetFiltersForm.renderFilters(html, event, searchParams);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    // Filter products by Style and Hardware collections if filter parameters exist
    // Use requestAnimationFrame to ensure DOM is fully updated
    requestAnimationFrame(() => {
      FacetFiltersForm.filterProductsByCollections();
    });
    
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
  }

  // Combined filter function that handles Style, Hardware, Length, Gauge, and Material filters
  static filterProductsByCollections() {
    const urlParams = new URLSearchParams(window.location.search);
    const styleFilters = urlParams.getAll('filter.p.collection.style');
    const hardwareFilters = urlParams.getAll('filter.p.collection.hardware');
    const lengthFilters = urlParams.getAll('filter.v.option.length');
    const gaugeFilters = urlParams.getAll('filter.v.option.gauge');
    
    // Get Material filters - check for both 'filter.v.option.material' and 'filter.v.option.metal-color'
    // Length and Gauge are handled server-side; exclude them from client-side material matching
    const SERVER_HANDLED_OPTION_FILTERS = new Set([
      'filter.v.option.length',
      'filter.v.option.gauge',
    ]);
    const materialFilters = [];
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter.v.option.') && !SERVER_HANDLED_OPTION_FILTERS.has(key)) {
        materialFilters.push({ key: key, value: value });
      }
    });
    
    // Get all product cards in the main collection grid only
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    
    const productCards = productGrid.querySelectorAll('.collection-product-card');
    if (productCards.length === 0) return;
    
    // If no custom filters are selected, show all products
    // Note: Material, Length and Gauge filters are handled server-side, but we still need to respect them
    if (styleFilters.length === 0 && hardwareFilters.length === 0 && lengthFilters.length === 0 && gaugeFilters.length === 0 && materialFilters.length === 0) {
      productCards.forEach(card => {
        card.style.display = '';
        card.removeAttribute('data-filtered-out');
      });
      return;
    }
    
    // Normalize style filter handles (lowercase, trimmed, URL decoded)
    const styleCollectionHandles = styleFilters.map(handle => {
      try {
        return decodeURIComponent(handle).toLowerCase().trim();
      } catch (e) {
        return handle.toLowerCase().trim();
      }
    }).filter(h => h !== ''); // Remove empty handles
    
    // Normalize hardware filter handles (lowercase, trimmed, URL decoded)
    const hardwareCollectionHandles = hardwareFilters.map(handle => {
      try {
        return decodeURIComponent(handle).toLowerCase().trim();
      } catch (e) {
        return handle.toLowerCase().trim();
      }
    }).filter(h => h !== ''); // Remove empty handles
    
    let visibleCount = 0;
    
    productCards.forEach((card, index) => {
      // Get style collections for this product
      const cardStyleCollections = card.getAttribute('data-style-collections') || '';
      const cardStyleArray = cardStyleCollections
        .split(',')
        .map(c => c.toLowerCase().trim())
        .filter(c => c !== '');
      
      // Get hardware collections for this product
      const cardHardwareCollections = card.getAttribute('data-hardware-collections') || '';
      const cardHardwareArray = cardHardwareCollections
        .split(',')
        .map(c => c.toLowerCase().trim())
        .filter(c => c !== '');
      
      // Check if product matches style filter (if style filter is active)
      let matchesStyle = true; // Default to true if no style filter
      if (styleCollectionHandles.length > 0) {
        matchesStyle = false;
        if (cardStyleArray.length > 0) {
          matchesStyle = styleCollectionHandles.some(selectedHandle => {
            return cardStyleArray.includes(selectedHandle);
          });
        }
      }
      
      // Check if product matches hardware filter (if hardware filter is active)
      let matchesHardware = true; // Default to true if no hardware filter
      if (hardwareCollectionHandles.length > 0) {
        matchesHardware = false;
        // Product must have hardware collections AND match at least one selected hardware filter
        if (cardHardwareArray.length > 0) {
          matchesHardware = hardwareCollectionHandles.some(selectedHandle => {
            return cardHardwareArray.includes(selectedHandle);
          });
        }
        // If product has no hardware collections but hardware filter is active, hide it
        // (matchesHardware already false if cardHardwareArray.length === 0)
      }
      
      // Check if product matches length filter (if length filter is active)
      // Note: Length filters are handled server-side, but we verify client-side for safety
      let matchesLength = true; // Default to true if no length filter
      if (lengthFilters.length > 0) {
        // Get length options from product card data attribute
        const cardLengthOptions = card.getAttribute('data-length-options') || '';
        const cardLengthArray = cardLengthOptions.split(',').map(l => l.toLowerCase().trim()).filter(l => l !== '');
        
        if (cardLengthArray.length > 0) {
          matchesLength = lengthFilters.some(selectedLength => {
            const normalizedSelected = decodeURIComponent(selectedLength).toLowerCase().trim();
            return cardLengthArray.some(cardLength => cardLength === normalizedSelected);
          });
        } else {
          // If product has no length data but length filter is active, hide it
          matchesLength = false;
        }
      }
      
      // Check if product matches gauge filter (if gauge filter is active)
      // Gauge relies on Shopify's server-side variant filter, but that filter can be
      // inactive/unconfigured, which lets products without the selected gauge leak in.
      // Verify client-side against the card's gauge options as a safety net.
      let matchesGauge = true; // Default to true if no gauge filter
      if (gaugeFilters.length > 0) {
        // Gauge values contain spaces, parentheses and dots (e.g. "14G (1.6mm)"),
        // and the card stores them as handles (e.g. "14g-1-6mm"), so normalize both
        // sides by stripping all non-alphanumeric characters before comparing.
        const normalizeGauge = (value) => {
          let decoded = value;
          try { decoded = decodeURIComponent(value); } catch (e) { decoded = value; }
          return decoded.toLowerCase().replace(/[^a-z0-9]/g, '');
        };

        const cardGaugeOptions = card.getAttribute('data-gauge-options') || '';
        const cardGaugeArray = cardGaugeOptions.split(',').map(g => normalizeGauge(g)).filter(g => g !== '');

        if (cardGaugeArray.length > 0) {
          matchesGauge = gaugeFilters.some(selectedGauge => {
            const normalizedSelected = normalizeGauge(selectedGauge);
            return cardGaugeArray.some(cardGauge => cardGauge === normalizedSelected);
          });
        } else {
          // If product has no gauge data but gauge filter is active, hide it
          matchesGauge = false;
        }
      }
      
      // Check if product matches material filter (if material filter is active)
      // Note: Material filters are variant-level and handled server-side, but we verify client-side
      let matchesMaterial = true; // Default to true if no material filter
      if (materialFilters.length > 0) {
        // Get material options from product card data attribute
        const cardMaterialOptions = card.getAttribute('data-material-options') || '';
        const cardMaterialArray = cardMaterialOptions.split(',').map(m => m.toLowerCase().trim()).filter(m => m !== '');
        
        if (cardMaterialArray.length > 0) {
          matchesMaterial = materialFilters.some(materialFilter => {
            const normalizedSelected = decodeURIComponent(materialFilter.value).toLowerCase().trim();
            return cardMaterialArray.some(cardMaterial => {
              // Try multiple matching strategies for material
              return cardMaterial === normalizedSelected ||
                     cardMaterial.includes(normalizedSelected) ||
                     normalizedSelected.includes(cardMaterial);
            });
          });
        } else {
          // If product has no material data but material filter is active, hide it
          matchesMaterial = false;
        }
      }
      
      // Product must match ALL active filters (AND logic)
      const shouldShow = matchesStyle && matchesHardware && matchesLength && matchesGauge && matchesMaterial;
      
      // Always set display style to ensure consistency
      // Use both style.display and a data attribute for reliability
      if (shouldShow) {
        card.style.display = '';
        card.removeAttribute('data-filtered-out');
        visibleCount++;
      } else {
        card.style.display = 'none';
        card.setAttribute('data-filtered-out', 'true');
      }
    });
    
    // Update product count if element exists
    const countElement = document.getElementById('ProductCount');
    const countElementDesktop = document.getElementById('ProductCountDesktop');
    if (countElement && visibleCount > 0) {
      const countText = countElement.textContent || '';
      const newCountText = countText.replace(/\d+/, visibleCount.toString());
      if (countElement.textContent !== newCountText) {
        countElement.textContent = newCountText;
        if (countElementDesktop) {
          countElementDesktop.textContent = newCountText;
        }
      }
    }
  }

  // Keep the old function for backward compatibility, but it now calls the combined function
  static filterProductsByStyle() {
    FacetFiltersForm.filterProductsByCollections();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event, searchParams = null) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    // Use requestAnimationFrame to ensure DOM is updated before restoring checkbox states
    // and ensuring custom filters are in sync
    requestAnimationFrame(() => {
      // Restore checkbox states based on the new search parameters (not the old URL)
      // This ensures checkboxes are correctly checked/unchecked based on the new filter state
      // Pass searchParams if available, otherwise read from URL
      FacetFiltersForm.restoreCheckboxStates(searchParams);
      
      // Also ensure custom filters are in sync with URL (remove if unchecked)
      // This handles the case when a checkbox is unchecked
      FacetFiltersForm.ensureCustomFiltersInActiveFacets();
    });
  }
  
  // Restore checkbox states based on search parameters
  // This ensures that checkboxes remain checked if they're in the parameters, even after page re-render
  // If searchParams is provided, use that; otherwise read from the current URL
  static restoreCheckboxStates(searchParams = null) {
    let urlParams;
    
    if (searchParams) {
      // Use the provided search parameters (the new state)
      // This is important because the URL might not be updated yet when this runs
      if (typeof searchParams === 'string') {
        urlParams = new URLSearchParams(searchParams);
      } else {
        urlParams = searchParams;
      }
    } else {
      // Fallback: read from the current URL
      const currentUrl = window.location.href;
      const urlSearch = currentUrl.includes('?') ? currentUrl.split('?')[1] : '';
      urlParams = new URLSearchParams(urlSearch);
    }
    
    // Get all filter checkboxes in the form
    const allCheckboxes = document.querySelectorAll('facet-filters-form input[type="checkbox"]');
    
    allCheckboxes.forEach(checkbox => {
      if (checkbox.name && checkbox.value) {
        // Check if this checkbox's parameter is in the search parameters
        const paramValues = urlParams.getAll(checkbox.name);
        // Decode both the parameter value and checkbox value for comparison
        const checkboxValueDecoded = decodeURIComponent(checkbox.value);
        const isInParams = paramValues.some(paramValue => {
          try {
            const paramValueDecoded = decodeURIComponent(paramValue);
            return paramValueDecoded === checkboxValueDecoded || paramValue === checkbox.value;
          } catch (e) {
            return paramValue === checkbox.value;
          }
        });
        
        // Set checkbox state based on search parameters
        // Only update if the state is different to avoid unnecessary DOM updates
        if (checkbox.checked !== isInParams) {
          checkbox.checked = isInParams;
        }
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!activeFacetsElement || !targetElement) return;
      // Update the active facets section with the new HTML from server response
      // This includes Style, Hardware, Length, Material, and other active filters
      targetElement.innerHTML = activeFacetsElement.innerHTML;
    })

    // Note: ensureCustomFiltersInActiveFacets is called after requestAnimationFrame
    // in renderFilters to ensure URL is updated and to remove unchecked filters

    FacetFiltersForm.toggleActiveFacets(false);
  }

  // Ensure custom filters (Style, Hardware, Length, Gauge) appear in active facets
  // Also remove active facets that are no longer in the URL (e.g., when checkbox is unchecked)
  static ensureCustomFiltersInActiveFacets() {
    // Read from current URL to get the most up-to-date filter state
    const currentUrl = window.location.href;
    const urlSearch = currentUrl.includes('?') ? currentUrl.split('?')[1] : '';
    const urlParams = new URLSearchParams(urlSearch);
    const styleFilters = urlParams.getAll('filter.p.collection.style');
    const hardwareFilters = urlParams.getAll('filter.p.collection.hardware');
    const lengthFilters = urlParams.getAll('filter.v.option.length');
    const gaugeFilters = urlParams.getAll('filter.v.option.gauge');
    
    // Handle both desktop and mobile active facets
    const activeFacetsWrappers = [
      document.querySelector('.active-facets-desktop .active-facets__wrapper'),
      document.querySelector('.active-facets-mobile .active-facets__wrapper')
    ].filter(wrapper => wrapper !== null);
    
    if (activeFacetsWrappers.length === 0) return;
    
    // Process each wrapper (desktop and mobile)
    activeFacetsWrappers.forEach(activeFacetsWrapper => {
    
    // Find the "Clear All" button - it's a facet-remove with a link that has class 'active-facets__button-remove'
    const clearAllButton = activeFacetsWrapper.querySelector('facet-remove a.active-facets__button-remove');
    const insertBeforeElement = clearAllButton ? clearAllButton.closest('facet-remove') : null;
    
    // Helper function to normalize filter values for comparison
    const normalizeValue = (value) => {
      try {
        return decodeURIComponent(value).toLowerCase().trim().replace(/\s+/g, '-');
      } catch (e) {
        return value.toLowerCase().trim().replace(/\s+/g, '-');
      }
    };
    
    // STEP 1: Remove ALL duplicates for ALL filter types (Style, Hardware, Length, Gauge)
    // This must happen first, before we check what exists
    // Use a more robust approach: check both text content and URL parameters from href
    const allActiveFacetButtons = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button')).filter(btn => {
      // Exclude the "Clear All" button
      return !btn.classList.contains('active-facets__button-remove');
    });
    
    // Group all buttons by filter type and parameter value (from href) or normalized label
    const buttonGroups = new Map();
    
    allActiveFacetButtons.forEach(btn => {
      const text = btn.textContent.trim();
      const href = btn.closest('a')?.href || '';
      let filterType = null;
      let label = null;
      let paramValue = null;
      let paramName = null;
      
      if (text.includes('Style:')) {
        filterType = 'style';
        label = text.replace(/Style:\s*/i, '').trim();
        paramName = 'filter.p.collection.style';
        // Extract parameter value from href
        const match = href.match(/filter\.p\.collection\.style=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Hardware:')) {
        filterType = 'hardware';
        label = text.replace(/Hardware:\s*/i, '').trim();
        paramName = 'filter.p.collection.hardware';
        // Extract parameter value from href
        const match = href.match(/filter\.p\.collection\.hardware=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Length:')) {
        filterType = 'length';
        label = text.replace(/Length:\s*/i, '').trim();
        paramName = 'filter.v.option.length';
        // Extract parameter value from href
        const match = href.match(/filter\.v\.option\.length=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Gauge:')) {
        filterType = 'gauge';
        label = text.replace(/Gauge:\s*/i, '').trim();
        paramName = 'filter.v.option.gauge';
        // Extract parameter value from href
        const match = href.match(/filter\.v\.option\.gauge=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      }
      
      if (filterType && label) {
        // Use parameter value for key if available (more reliable), otherwise use normalized label
        const key = paramValue ? `${filterType}:${normalizeValue(paramValue)}` : `${filterType}:${normalizeValue(label)}`;
        
        if (!buttonGroups.has(key)) {
          buttonGroups.set(key, []);
        }
        buttonGroups.get(key).push(btn);
      }
    });
    
    // Remove duplicates (keep only the first one for each unique filter)
    buttonGroups.forEach((buttons, key) => {
      if (buttons.length > 1) {
        // Remove all but the first one
        for (let i = 1; i < buttons.length; i++) {
          const facetRemove = buttons[i].closest('facet-remove');
          if (facetRemove) {
            facetRemove.remove();
          }
        }
      }
    });
    
    // STEP 2: Remove active facets that are displayed but NOT in the URL
    // This handles the case when a checkbox is unchecked
    const remainingActiveFacetButtons = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button')).filter(btn => {
      // Exclude the "Clear All" button
      return !btn.classList.contains('active-facets__button-remove');
    });
    
    remainingActiveFacetButtons.forEach(button => {
      const buttonText = button.textContent.trim();
      let shouldRemove = false;
      
      // Check if this is a Style filter
      if (buttonText.includes('Style:')) {
        const styleLabel = buttonText.replace(/Style:\s*/i, '').trim();
        // Normalize the label to match URL format (e.g., "Segment Ring" -> "segment-ring")
        const normalizedStyleLabel = normalizeValue(styleLabel);
        
        // Check if this style filter is in the current URL
        // If styleFilters is empty, remove all style facets
        // If styleFilters has values but this one isn't in it, remove this facet
        const isInUrl = styleFilters.length > 0 && styleFilters.some(urlValue => {
          const normalizedUrlValue = normalizeValue(urlValue);
          // Try multiple matching strategies to handle different formats
          return normalizedUrlValue === normalizedStyleLabel || 
                 normalizedUrlValue.replace(/-/g, ' ') === styleLabel.toLowerCase().trim() ||
                 normalizedStyleLabel.replace(/-/g, ' ') === styleLabel.toLowerCase().trim() ||
                 // Direct text matching
                 buttonText.toLowerCase().includes(urlValue.toLowerCase()) ||
                 urlValue.toLowerCase().includes(styleLabel.toLowerCase());
        });
        
        // Remove if no style filters in URL, or if this specific one is not in URL
        shouldRemove = styleFilters.length === 0 || !isInUrl;
      }
      // Check if this is a Hardware filter
      else if (buttonText.includes('Hardware:')) {
        const hardwareLabel = buttonText.replace(/Hardware:\s*/i, '').trim();
        const normalizedHardwareLabel = normalizeValue(hardwareLabel);
        // Check if this hardware filter is in the URL
        const isInUrl = hardwareFilters.some(urlValue => {
          const normalizedUrlValue = normalizeValue(urlValue);
          const normalizedLabelWithSpaces = hardwareLabel.toLowerCase().trim();
          return normalizedUrlValue === normalizedHardwareLabel || 
                 normalizedUrlValue === normalizedLabelWithSpaces ||
                 normalizedUrlValue.replace(/-/g, ' ') === normalizedLabelWithSpaces;
        });
        shouldRemove = !isInUrl;
      }
      // Check if this is a Length filter
      else if (buttonText.includes('Length:')) {
        const lengthLabel = buttonText.replace(/Length:\s*/i, '').trim();
        const normalizedLengthLabel = normalizeValue(lengthLabel);
        // Check if this length filter is in the URL
        const isInUrl = lengthFilters.some(urlValue => {
          const normalizedUrlValue = normalizeValue(urlValue);
          return normalizedUrlValue === normalizedLengthLabel || 
                 normalizedUrlValue === lengthLabel.toLowerCase().trim();
        });
        shouldRemove = !isInUrl;
      }
      // Check if this is a Gauge filter
      else if (buttonText.includes('Gauge:')) {
        const gaugeLabel = buttonText.replace(/Gauge:\s*/i, '').trim();
        const normalizedGaugeLabel = normalizeValue(gaugeLabel);
        // Check if this gauge filter is in the URL
        const isInUrl = gaugeFilters.some(urlValue => {
          const normalizedUrlValue = normalizeValue(urlValue);
          return normalizedUrlValue === normalizedGaugeLabel || 
                 normalizedUrlValue === gaugeLabel.toLowerCase().trim();
        });
        shouldRemove = !isInUrl;
      }
      
      if (shouldRemove) {
        // Remove this active facet because it's not in the URL anymore
        const facetRemove = button.closest('facet-remove');
        if (facetRemove) {
          facetRemove.remove();
        }
      }
    });
    
    // STEP 3: Add filters that are in the URL but not in active facets
    // For Style filters, use a simpler and more reliable approach:
    // Check each URL parameter value directly against href attributes
    styleFilters.forEach(styleValue => {
      const decodedValue = decodeURIComponent(styleValue);
      const normalizedUrlValue = normalizeValue(decodedValue);
      const styleLabel = decodedValue.replace(/-/g, ' ').split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      // Get all existing Style filter links and check their href parameter values
      const existingStyleLinks = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button a')).filter(link => {
        if (link.classList.contains('active-facets__button-remove')) return false;
        const text = link.textContent.trim();
        return text.includes('Style:');
      });
      
      // Check if this specific styleValue is already displayed by checking href parameter values
      let isDisplayed = false;
      for (const link of existingStyleLinks) {
        const href = link.href || '';
        const hrefMatch = href.match(/filter\.p\.collection\.style=([^&]+)/);
        if (hrefMatch) {
          let hrefParamValue = null;
          try {
            hrefParamValue = decodeURIComponent(hrefMatch[1]);
          } catch (e) {
            hrefParamValue = hrefMatch[1];
          }
          
          // Compare normalized values - this is the most reliable match
          const normalizedHrefValue = normalizeValue(hrefParamValue);
          if (normalizedHrefValue === normalizedUrlValue) {
            isDisplayed = true;
            break;
          }
          
          // Also try direct comparison with original values (in case encoding differs)
          if (normalizeValue(styleValue) === normalizedHrefValue ||
              normalizeValue(decodedValue) === normalizedHrefValue ||
              hrefParamValue === styleValue ||
              hrefParamValue === decodedValue) {
            isDisplayed = true;
            break;
          }
        }
      }
      
      // If not displayed, add it
      if (!isDisplayed) {
        const removeUrl = FacetFiltersForm.buildRemoveUrl('filter.p.collection.style', styleValue);
        const styleButton = FacetFiltersForm.createActiveFacetButton('Style', styleLabel, removeUrl);
        if (insertBeforeElement) {
          activeFacetsWrapper.insertBefore(styleButton, insertBeforeElement);
        } else {
          activeFacetsWrapper.appendChild(styleButton);
        }
      }
    });
    
    // Check if Hardware filters are in URL but not in active facets
    hardwareFilters.forEach(hardwareValue => {
      const decodedValue = decodeURIComponent(hardwareValue);
      const normalizedUrlValue = normalizeValue(decodedValue);
      const hardwareLabel = decodedValue.replace(/-/g, ' ').split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      // Get all existing Hardware filter links and check their href parameter values
      const existingHardwareLinks = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button a')).filter(link => {
        if (link.classList.contains('active-facets__button-remove')) return false;
        const text = link.textContent.trim();
        return text.includes('Hardware:');
      });
      
      // Check if this specific hardwareValue is already displayed by checking href parameter values
      let isDisplayed = false;
      for (const link of existingHardwareLinks) {
        const href = link.href || '';
        const hrefMatch = href.match(/filter\.p\.collection\.hardware=([^&]+)/);
        if (hrefMatch) {
          let hrefParamValue = null;
          try {
            hrefParamValue = decodeURIComponent(hrefMatch[1]);
          } catch (e) {
            hrefParamValue = hrefMatch[1];
          }
          
          // Compare normalized values - this is the most reliable match
          const normalizedHrefValue = normalizeValue(hrefParamValue);
          if (normalizedHrefValue === normalizedUrlValue) {
            isDisplayed = true;
            break;
          }
          
          // Also try direct comparison with original values (in case encoding differs)
          if (normalizeValue(hardwareValue) === normalizedHrefValue ||
              normalizeValue(decodedValue) === normalizedHrefValue ||
              hrefParamValue === hardwareValue ||
              hrefParamValue === decodedValue) {
            isDisplayed = true;
            break;
          }
        }
      }
      
      // If not displayed, add it
      if (!isDisplayed) {
        const removeUrl = FacetFiltersForm.buildRemoveUrl('filter.p.collection.hardware', hardwareValue);
        const hardwareButton = FacetFiltersForm.createActiveFacetButton('Hardware', hardwareLabel, removeUrl);
        if (insertBeforeElement) {
          activeFacetsWrapper.insertBefore(hardwareButton, insertBeforeElement);
        } else {
          activeFacetsWrapper.appendChild(hardwareButton);
        }
      }
    });
    
    // Final safety check for Style filters: Ensure all URL parameters have corresponding active facets
    // This double-checks to catch any that might have been missed
    const finalStyleLinks = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button a')).filter(link => {
      if (link.classList.contains('active-facets__button-remove')) return false;
      return link.textContent.trim().includes('Style:');
    });
    
    if (styleFilters.length !== finalStyleLinks.length) {
      // Count mismatch - add any missing filters
      styleFilters.forEach(styleValue => {
        const decodedValue = decodeURIComponent(styleValue);
        const normalizedUrlValue = normalizeValue(decodedValue);
        
        // Check if this value exists in any of the current links
        const exists = finalStyleLinks.some(link => {
          const href = link.href || '';
          const hrefMatch = href.match(/filter\.p\.collection\.style=([^&]+)/);
          if (hrefMatch) {
            try {
              const hrefValue = decodeURIComponent(hrefMatch[1]);
              return normalizeValue(hrefValue) === normalizedUrlValue;
            } catch (e) {
              return normalizeValue(hrefMatch[1]) === normalizedUrlValue;
            }
          }
          return false;
        });
        
        if (!exists) {
          // Missing filter - add it
          const styleLabel = decodedValue.replace(/-/g, ' ').split(' ').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ');
          const removeUrl = FacetFiltersForm.buildRemoveUrl('filter.p.collection.style', styleValue);
          const styleButton = FacetFiltersForm.createActiveFacetButton('Style', styleLabel, removeUrl);
          if (insertBeforeElement) {
            activeFacetsWrapper.insertBefore(styleButton, insertBeforeElement);
          } else {
            activeFacetsWrapper.appendChild(styleButton);
          }
        }
      });
    }
    
    // Check if Length filters are in URL but not in active facets
    lengthFilters.forEach(lengthValue => {
      const decodedValue = decodeURIComponent(lengthValue);
      const normalizedUrlValue = normalizeValue(decodedValue);
      
      // Check if this Length filter is already displayed - use more accurate matching
      // Check both text content and href parameter value
      const existingLengthFilter = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button')).find(btn => {
        if (btn.classList.contains('active-facets__button-remove')) return false; // Skip Clear All button
        
        const text = btn.textContent.trim();
        if (!text.includes('Length:')) return false;
        
        const buttonLabel = text.replace(/Length:\s*/i, '').trim();
        const normalizedButtonLabel = normalizeValue(buttonLabel);
        
        // Also check the href for parameter value match
        const href = btn.closest('a')?.href || '';
        const hrefMatch = href.match(/filter\.v\.option\.length=([^&]+)/);
        let hrefParamValue = null;
        if (hrefMatch) {
          try {
            hrefParamValue = decodeURIComponent(hrefMatch[1]);
          } catch (e) {
            hrefParamValue = hrefMatch[1];
          }
        }
        
        // Check multiple matching strategies including href parameter
        return (hrefParamValue && (normalizeValue(hrefParamValue) === normalizedUrlValue || normalizeValue(hrefParamValue) === normalizeValue(lengthValue))) ||
               normalizedButtonLabel === normalizedUrlValue ||
               normalizedButtonLabel === decodedValue.toLowerCase().trim() ||
               text.toLowerCase().includes(decodedValue.toLowerCase()) ||
               decodedValue.toLowerCase().includes(buttonLabel.toLowerCase());
      });
      
      if (!existingLengthFilter) {
        const removeUrl = FacetFiltersForm.buildRemoveUrl('filter.v.option.length', lengthValue);
        const lengthButton = FacetFiltersForm.createActiveFacetButton('Length', decodedValue, removeUrl);
        if (insertBeforeElement) {
          activeFacetsWrapper.insertBefore(lengthButton, insertBeforeElement);
        } else {
          activeFacetsWrapper.appendChild(lengthButton);
        }
      }
    });
    
    // Check if Gauge filters are in URL but not in active facets
    gaugeFilters.forEach(gaugeValue => {
      const decodedValue = decodeURIComponent(gaugeValue);
      const normalizedUrlValue = normalizeValue(decodedValue);
      
      // Check if this Gauge filter is already displayed - use more accurate matching
      // Check both text content and href parameter value
      const existingGaugeFilter = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button')).find(btn => {
        if (btn.classList.contains('active-facets__button-remove')) return false; // Skip Clear All button
        
        const text = btn.textContent.trim();
        if (!text.includes('Gauge:')) return false;
        
        const buttonLabel = text.replace(/Gauge:\s*/i, '').trim();
        const normalizedButtonLabel = normalizeValue(buttonLabel);
        
        // Also check the href for parameter value match
        const href = btn.closest('a')?.href || '';
        const hrefMatch = href.match(/filter\.v\.option\.gauge=([^&]+)/);
        let hrefParamValue = null;
        if (hrefMatch) {
          try {
            hrefParamValue = decodeURIComponent(hrefMatch[1]);
          } catch (e) {
            hrefParamValue = hrefMatch[1];
          }
        }
        
        // Check multiple matching strategies including href parameter
        return (hrefParamValue && (normalizeValue(hrefParamValue) === normalizedUrlValue || normalizeValue(hrefParamValue) === normalizeValue(gaugeValue))) ||
               normalizedButtonLabel === normalizedUrlValue ||
               normalizedButtonLabel === decodedValue.toLowerCase().trim() ||
               text.toLowerCase().includes(decodedValue.toLowerCase()) ||
               decodedValue.toLowerCase().includes(buttonLabel.toLowerCase());
      });
      
      if (!existingGaugeFilter) {
        const removeUrl = FacetFiltersForm.buildRemoveUrl('filter.v.option.gauge', gaugeValue);
        const gaugeButton = FacetFiltersForm.createActiveFacetButton('Gauge', decodedValue, removeUrl);
        if (insertBeforeElement) {
          activeFacetsWrapper.insertBefore(gaugeButton, insertBeforeElement);
        } else {
          activeFacetsWrapper.appendChild(gaugeButton);
        }
      }
    });
    
    // STEP 4: Final cleanup - remove any remaining duplicates that might have been created
    // This is a safety net to catch any duplicates that slipped through
    const finalActiveFacetButtons = Array.from(activeFacetsWrapper.querySelectorAll('facet-remove .active-facets__button')).filter(btn => {
      return !btn.classList.contains('active-facets__button-remove');
    });
    
    const finalButtonGroups = new Map();
    finalActiveFacetButtons.forEach(btn => {
      const text = btn.textContent.trim();
      const href = btn.closest('a')?.href || '';
      let filterType = null;
      let paramValue = null;
      
      if (text.includes('Style:')) {
        filterType = 'style';
        const match = href.match(/filter\.p\.collection\.style=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Hardware:')) {
        filterType = 'hardware';
        const match = href.match(/filter\.p\.collection\.hardware=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Length:')) {
        filterType = 'length';
        const match = href.match(/filter\.v\.option\.length=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      } else if (text.includes('Gauge:')) {
        filterType = 'gauge';
        const match = href.match(/filter\.v\.option\.gauge=([^&]+)/);
        if (match) paramValue = decodeURIComponent(match[1]);
      }
      
      if (filterType && paramValue) {
        const key = `${filterType}:${normalizeValue(paramValue)}`;
        if (!finalButtonGroups.has(key)) {
          finalButtonGroups.set(key, []);
        }
        finalButtonGroups.get(key).push(btn);
      } else if (filterType) {
        // Fallback: use normalized label if param value not found
        const label = text.replace(/(Style|Hardware|Length|Gauge):\s*/i, '').trim();
        const key = `${filterType}:${normalizeValue(label)}`;
        if (!finalButtonGroups.has(key)) {
          finalButtonGroups.set(key, []);
        }
        finalButtonGroups.get(key).push(btn);
      }
    });
    
    // Remove any remaining duplicates
    finalButtonGroups.forEach((buttons, key) => {
      if (buttons.length > 1) {
        // Keep the first one, remove the rest
        for (let i = 1; i < buttons.length; i++) {
          const facetRemove = buttons[i].closest('facet-remove');
          if (facetRemove) {
            facetRemove.remove();
          }
        }
      }
    });
    
    }); // End of forEach loop for activeFacetsWrappers
  }

  // Build a URL to remove a specific filter parameter
  static buildRemoveUrl(paramName, paramValue) {
    const urlParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();
    
    // Copy all params except the one being removed
    urlParams.forEach((value, key) => {
      if (key !== paramName || value !== paramValue) {
        newParams.append(key, value);
      }
    });
    
    const baseUrl = window.location.pathname;
    const queryString = newParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }

  // Create an active facet button element
  static createActiveFacetButton(filterType, filterLabel, removeUrl) {
    // Clone an existing active facet button to get the structure and icon
    const existingButton = document.querySelector('.active-facets__button');
    if (existingButton) {
      const facetRemove = document.createElement('facet-remove');
      const link = existingButton.cloneNode(true);
      link.href = removeUrl;
      
      // Update the button text
      const inner = link.querySelector('.active-facets__button-inner');
      if (inner) {
        // Remove existing text content but keep the close icon
        const closeIcon = inner.querySelector('.active-facets__button-close');
        inner.innerHTML = '';
        
        const labelSpan = document.createElement('span');
        labelSpan.textContent = `${filterType}: `;
        inner.appendChild(labelSpan);
        
        const labelText = document.createTextNode(filterLabel);
        inner.appendChild(labelText);
        
        if (closeIcon) {
          inner.appendChild(closeIcon.cloneNode(true));
        } else {
          // Create a simple close icon if none exists
          const closeSpan = document.createElement('span');
          closeSpan.className = 'active-facets__button-close';
          closeSpan.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          inner.appendChild(closeSpan);
        }
      }
      
      facetRemove.appendChild(link);
      return facetRemove;
    }
    
    // Fallback: create from scratch
    const facetRemove = document.createElement('facet-remove');
    const link = document.createElement('a');
    link.href = removeUrl;
    link.className = 'active-facets__button focus-inset';
    
    const inner = document.createElement('span');
    inner.className = 'active-facets__button-inner';
    
    const labelSpan = document.createElement('span');
    labelSpan.textContent = `${filterType}: `;
    inner.appendChild(labelSpan);
    
    const labelText = document.createTextNode(filterLabel);
    inner.appendChild(labelText);
    
    // Create close icon
    const closeSpan = document.createElement('span');
    closeSpan.className = 'active-facets__button-close';
    closeSpan.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    inner.appendChild(closeSpan);
    
    const visuallyHidden = document.createElement('span');
    visuallyHidden.className = 'visually-hidden';
    visuallyHidden.textContent = 'Clear filter';
    
    link.appendChild(inner);
    link.appendChild(visuallyHidden);
    facetRemove.appendChild(link);
    
    return facetRemove;
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const self = this;
    
    // For checkbox inputs, read the state immediately before any async operations
    // This ensures we capture the actual checkbox state (checked or unchecked)
    let checkboxState = null;
    if (event.target && event.target.type === 'checkbox') {
      // Capture the checkbox state immediately
      checkboxState = {
        name: event.target.name,
        value: event.target.value,
        checked: event.target.checked
      };
    }
    
    // Use requestAnimationFrame to ensure checkbox states are updated
    requestAnimationFrame(() => {
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event.srcElement.className == 'mobile-facets__checkbox') {
        const form = event.target.closest('form');
        if (form) {
          const searchParams = self.createSearchParams(form);
          self.onSubmitForm(searchParams, event);
        }
      } else {
        const closestForm = event.target.closest('form');
        const isMobile = closestForm && closestForm.id === 'FacetFiltersFormMobile';

        // Collect all checked checkboxes from all filter forms to preserve all active filters
        // This ensures that when one filter is changed, other active filters are preserved
        const allParams = new URLSearchParams();
        
        // Collect all checked filter checkboxes from the entire facet-filters-form
        // This includes: Style, Hardware, Length, Material, and any other filter checkboxes
        // Use a fresh query to ensure we get the current state
        // Query from the entire document to catch all filter checkboxes, including Material
        const allFilterCheckboxes = document.querySelectorAll('facet-filters-form input[type="checkbox"]');
        const seenParams = new Set();
        
        // Collect all checked checkboxes - this includes Material, Style, Hardware, Length, etc.
        // Material filters use parameter names like filter.v.option.material or similar
        allFilterCheckboxes.forEach(checkbox => {
          // If this is the checkbox that was just clicked, use the captured state
          // Otherwise, use the current DOM state
          let isChecked = checkbox.checked;
          if (checkboxState && checkbox.name === checkboxState.name && checkbox.value === checkboxState.value) {
            isChecked = checkboxState.checked;
          }
          
          if (checkbox.name && checkbox.value && isChecked) {
            const paramKey = `${checkbox.name}\0${checkbox.value}`;
            if (!seenParams.has(paramKey)) {
              seenParams.add(paramKey);
              allParams.append(checkbox.name, checkbox.value);
            }
          }
        });
      
        // Then, collect other form inputs (like sort, price range, etc.) from the specific forms
        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              
              // Get all form inputs (excluding checkboxes which we already collected)
              const formInputs = form.querySelectorAll('input:not([type="checkbox"]), select');
              formInputs.forEach(input => {
                if (input.name && input.value) {
                  // Only add if not a filter checkbox (we already collected those)
                  if (!input.name.startsWith('filter.p.collection.') && 
                      !input.name.startsWith('filter.v.option.')) {
                    allParams.set(input.name, input.value);
                  }
                }
              });
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            // For mobile, collect all inputs except checkboxes (already collected)
            const formInputs = form.querySelectorAll('input:not([type="checkbox"]), select');
            formInputs.forEach(input => {
              if (input.name && input.value) {
                if (!input.name.startsWith('filter.p.collection.') && 
                    !input.name.startsWith('filter.v.option.')) {
                  allParams.set(input.name, input.value);
                }
              }
            });
          }
        });
        
        self.onSubmitForm(allParams.toString(), event);
      }
    });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Clear all filters on page refresh/load
FacetFiltersForm.clearAllFiltersOnLoad = function() {
  // Check if this is a page load/refresh
  // Use performance API to detect navigation type
  let navigationType = null;
  try {
    const navEntry = performance.getEntriesByType('navigation')[0];
    navigationType = navEntry?.type;
  } catch (e) {
    // Fallback for older browsers
    navigationType = performance.navigation?.type === 1 ? 'reload' : 'navigate';
  }
  
  // Check if URL has filter parameters
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilterParams = Array.from(urlParams.keys()).some(key => 
    key.startsWith('filter.p.collection.') || 
    key.startsWith('filter.v.option.') ||
    key.startsWith('filter.')
  );
  
  // If this is a page refresh/reload and there are filter parameters, clear them
  // Only clear on actual page refresh, not on initial navigation
  if (navigationType === 'reload' && hasFilterParams) {
    // Build clean URL without filter parameters
    const cleanParams = new URLSearchParams();
    urlParams.forEach((value, key) => {
      // Keep non-filter parameters (like sort, page, etc.)
      if (!key.startsWith('filter.p.collection.') && 
          !key.startsWith('filter.v.option.') &&
          !key.startsWith('filter.')) {
        cleanParams.append(key, value);
      }
    });
    
    // Uncheck all filter checkboxes
    const allCheckboxes = document.querySelectorAll('facet-filters-form input[type="checkbox"]');
    allCheckboxes.forEach(checkbox => {
      if (checkbox.name && (
          checkbox.name.startsWith('filter.p.collection.') || 
          checkbox.name.startsWith('filter.v.option.') ||
          checkbox.name.startsWith('filter.')
        )) {
        checkbox.checked = false;
      }
    });
    
    // Build clean URL
    const cleanUrl = cleanParams.toString() 
      ? `${window.location.pathname}?${cleanParams.toString()}`
      : window.location.pathname;
    
    // Redirect to clean URL without filters
    if (window.location.href.split('?')[0] + (cleanParams.toString() ? '?' + cleanParams.toString() : '') !== window.location.href) {
      window.location.href = cleanUrl;
    }
  }
};

// Filter products by Style and Hardware collections on page load
document.addEventListener('DOMContentLoaded', () => {
  // Clear all filters on page refresh/load
  FacetFiltersForm.clearAllFiltersOnLoad();
  
  // Restore checkbox states based on URL parameters (after clearing, this will uncheck everything)
  FacetFiltersForm.restoreCheckboxStates();
  
  // Run immediately
  FacetFiltersForm.filterProductsByCollections();
  
  // Also run after a delay to catch any late-rendered products
  setTimeout(() => {
    FacetFiltersForm.filterProductsByCollections();
    // Restore checkbox states again after products are loaded
    FacetFiltersForm.restoreCheckboxStates();
  }, 100);
  
  // Use MutationObserver to filter when products are added/updated
  const productGrid = document.getElementById('product-grid');
  if (productGrid) {
    const observer = new MutationObserver(() => {
      FacetFiltersForm.filterProductsByCollections();
    });
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
});

// Also filter after a short delay to ensure products are rendered
setTimeout(() => {
  FacetFiltersForm.filterProductsByCollections();
}, 500);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
